import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadComponent } from './file-upload/file-upload.component';

import { ImageCropperComponent as ngxImageCropperComponent } from 'ngx-image-cropper';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';
import { PipesModule } from '../pipes/pipes.module';
import { FieldViewOnlyRowComponent } from './field-view-only-row/field-view-only-row.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { InlineAlertComponent } from './inline-alert/inline-alert.component';
import { MultipleFileUploadComponent } from './multiple-file-upload/multiple-file-upload.component';
import { OverlayBackgroundComponent } from './overlay-background/overlay-background.component';
import { PillComponent } from './pill/pill.component';
import { SkeletonTemplateComponent } from './skeleton-template/skeleton-template.component';
import { StatusIndicatorComponent } from './status-indicator/status-indicator.component';
import { TooltipModule } from './tooltip/tooltip.module';

import { AdminHeaderComponent } from './admin/admin-header/admin-header.component';
//import { AdminFilterComponent } from './admin/admin-filter/admin-filter.component';
import { AdminNavSearchFilterComponent } from './admin/admin-nav-search-filter/admin-nav-search-filter.component';
import { YesNoModalComponent } from './admin/yes-no-modal/yes-no-modal.component';

import { ScrollerModule } from 'primeng/scroller';
import { AdminFilterComponent } from "./admin/admin-filter/admin-filter.component";
import { SortIcon, TableModule } from "primeng/table";

import { AccordionModule } from "./accordion/accordion.module";
import { SideNavComponent } from './side-nav/side-nav.component';
import { UlNavComponent } from './ul-nav/ul-nav.component';
import { Tooltip } from "primeng/tooltip";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { ButtonModule } from 'primeng/button';
import { Select } from "primeng/select";
import { OverlayModule } from "primeng/overlay";
import { Popover } from "primeng/popover";
import { ProgressBarComponent } from "./progress-bar/progress-bar.component";

import { ProgressBarModule } from 'primeng/progressbar';
@NgModule({
    imports: [
        MenuModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        FileUploadModule,
        PipesModule,
        SkeletonModule,
        DialogModule,
        ScrollerModule,
        TableModule,
        NgOptimizedImage,
        AccordionModule,
        TableModule,
        Tooltip,
        RouterLinkActive,
        RouterLink,
        ButtonModule,
        MenuModule,
        DialogModule,
        ngxImageCropperComponent,
        Select,
        OverlayModule,
        ProgressBarModule,
        Popover,
        FileUploadComponent,
        MultipleFileUploadComponent,
        StatusIndicatorComponent,
        PillComponent,
        FieldViewOnlyRowComponent,
        ImageCropperComponent,
        SkeletonTemplateComponent,
        InlineAlertComponent,
        OverlayBackgroundComponent,
        AdminNavSearchFilterComponent,
        YesNoModalComponent,
        AdminHeaderComponent,
        AdminFilterComponent,
        ProgressBarComponent,
        SideNavComponent,
        UlNavComponent,
    ],
    exports: [
        FileUploadComponent,
        MultipleFileUploadComponent,
        StatusIndicatorComponent,
        TooltipModule,
        SortIcon,
        ngxImageCropperComponent,
        SortIcon,
        PillComponent,
        FieldViewOnlyRowComponent,
        ImageCropperComponent,
        SkeletonTemplateComponent,
        InlineAlertComponent,
        ProgressBarComponent,
        OverlayBackgroundComponent,
        AdminNavSearchFilterComponent,
        YesNoModalComponent,
        AdminHeaderComponent,
        ScrollerModule,
        AdminFilterComponent,
        SideNavComponent,
        UlNavComponent,
        ButtonModule,
        MenuModule,
        DialogModule,
        Popover,
    ],
    providers: [],
})
export class ComponentsModule {
}
